import { useAuth } from "context/AuthContext";
import { NavLink } from "react-router-dom";

type Props = {
  to: string;
  icon: any;
  icon2: any;
  title: string;
};

const SidebarButton = (props: Props) => {
  const { user } = useAuth();
  return (
    <NavLink to={props.to} className={({ isActive }) => (isActive ? "" : "")}>
      {({ isActive }) => (
        <button
          className={` ${
            user.role === "owner" && props.title === "Offers" ? "hidden" : ""
          } ${
            isActive
              ? " active-icon rounded-[28px] bg-primary pl-6 h-[40px] font-[500] font-nunito text-[14px] text-white mt-[3%] flex items-center ml-10 w-[70%] "
              : "inactive-icon w-[70%] h-[40px] font-[500] pl-6 font-nunito text-[14px] text-[#17191C] flex items-center mt-[3%] ml-10 hover:scale-[1.1] transform duration-300 "
          }`}
        >
          <span className="mr-[8px] ">
            {isActive ? props.icon : props.icon2}
          </span>
          {props.title}
        </button>
      )}
    </NavLink>
  );
};

export default SidebarButton;
